export const createCancellablePromise = (logicFunction) => {
	// State for managing cleanup and cancelling
	let finished = false;
	let cancel = () => (finished = true);

	const promise = new Promise((resolve, reject) => {
		logicFunction().then((ret) => {
			resolve(ret);
		});
		// When consumer calls `cancel`:
		cancel = () => {
			// In case the promise has already resolved/rejected, don't run cancel behavior!
			if (finished) {
				return;
			}

			// Cancel-path scenario
			reject({ error: 'stopped' });
		};

		// If was cancelled before promise was launched, trigger cancel logic
		if (finished) {
			// (to avoid duplication, just calling `cancel`)
			cancel();
		}
	})
		// After any scenario, set `finished = true` so cancelling has no effect
		.then((resolvedValue) => {
			finished = true;
			return resolvedValue;
		})
		.catch((err) => {
			finished = true;
			return err;
		});

	// ES6 Promises do not have a built-in mechanism for cancelling promises.
	// To support that feature, you need to provide the cancel callback
	// and consider the possible timings:
	// - cancelled before promise execution
	// - cancelled during promise execution
	// - cancelled after promise execution
	// - cancel requested multiple times
	return { promise, cancel };
};

const DEFAULT_WATCHER_SERVICE = { deep: false, immediate: false };
export const buildWatcherStoreObject = (fnOrExpr, callback, options) => ({
	fnOrExpr,
	callback,
	options: { ...DEFAULT_WATCHER_SERVICE, ...options },
});
